import React from 'react';

// This usercontext is for demo purpose
// This is the equivalent to the createStore method of Redux
// https://redux.js.org/api/createstore

const UserContext = React.createContext();

export default UserContext;